import { render, staticRenderFns } from "./Charts.vue?vue&type=template&id=33880660&scoped=true&"
import script from "./Charts.vue?vue&type=script&lang=js&"
export * from "./Charts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33880660",
  null
  
)

export default component.exports